<template>
  <ExpandableCell
    :data-key="dataKey"
    :field="column.field"
    @toggleExpansion="$emit('toggleExpansion', $event)"
  >
    <template #collapsed>
      {{ compactPhone }}
    </template>

    <template #expanded>
      {{ fullPhone }}
    </template>
  </ExpandableCell>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { formatInternationalPhoneNumber } from '@/utils/string';

import type { PaginatedDataTableCellProps } from './templateTypes';

defineEmits(['toggleExpansion']);

const props = defineProps<PaginatedDataTableCellProps<string | number>>();

const fullPhone = computed(() => {
  const rawValue = props.cell as string | number | undefined | null;
  if (rawValue == null) return '';

  const value = String(rawValue).trim();
  if (!value) return '';

  return formatInternationalPhoneNumber(value);
});

const compactPhone = computed(() => fullPhone.value);
</script>
